import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Radio } from 'react-icheck'

const globalPermissions = ['MANAGE_TENANT', 'MANAGE_WIDGETS']
const roles = ['user', 'manager']

const RolesAndPermissions = ({ user, onSelectRole, onCheckPermission }) => (
  <div>
    <label>Roles and Permissions:</label>
    <div className='note note-info'>
      <div className='form-group'>
        <label className='control-label'>Roles</label>
        <div className='input-group'>
          <div className='icheck-inline'>
            {roles.map(role => (
              <Radio
                key={role}
                name='role'
                radioClass='iradio_square-aero'
                label={role}
                checked={role === user.role}
                onChange={() => onSelectRole(role)}
              />
            ))}
          </div>
        </div>
      </div>

      <div className='form-group'>
        <label className='control-label'>Permissions</label>
        <div className='input-group'>
          <div className='icheck-list'>
            {globalPermissions.map(permission => (
              <Checkbox
                key={permission}
                checkboxClass='icheckbox_square-aero'
                label={permission.replace(/_/g, ' ')}
                checked={
                  user.permissions ? (
                    user.permissions.includes(permission)
                  ) : (
                    false
                  )
                }
                onChange={e => onCheckPermission(permission, e.target.checked)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
)

RolesAndPermissions.propTypes = {
  user: PropTypes.object.isRequired,
  onSelectRole: PropTypes.func.isRequired,
  onCheckPermission: PropTypes.func.isRequired
}

export default RolesAndPermissions



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/tenant-permissions/roles-and-permissions.js